import {ReactNode, FC} from 'react';

import {Grid, GridProps} from '@mui/material';

interface PdfPageBreakWrapper extends GridProps {
  children: ReactNode;
}

export const PdfPageBreakWrapper: FC<PdfPageBreakWrapper> = ({children, ...props}) => {
  return (
    <Grid className='pdf-section-break' {...props}>
      {children}
    </Grid>
  );
};
